import './FooterInfo.css'
import { Link, NavLink } from 'react-router-dom'
import { Button } from '@mantine/core'
import { footerItems } from '../../../utils/consts'
import forvetLogoFooter from '../../../assets/footer/forvet_logo_footer.png'
import forvetLogoGolden from '../../../assets/fv_logo-golden.png'
import useEliteStatus from '../../../hooks/useEliteStatus'

export default function FooterInfo() {

   const isElite = useEliteStatus()

   const logo = isElite ? forvetLogoGolden : forvetLogoFooter

   return (
      <div className='footer-info-container'>
         <div className='footer-logo-container'>
            <div className='footer-column-container'>
               < img className={isElite ? "footer-logo-golden": "footer-logo-image"} src={logo} alt='Forvet | Formacion Integral Veterinaria' />
               <Button variant='outline' color={'#FFF'} component={Link} to='/contacto' w='100%' >CONTACTO</Button>
            </div>
         </div>
         <div className='footer-contact-container'>
            <div className='footer-column-container'>
               <h4 className='footer-column-title'>Contacto y Ayuda</h4>
               {footerItems.filter(item => item.isContactItem).map(i => (
                  <Link key={i.text}
                  to={i.to}
                  className='footer-item-container'
                  target={i.target ? '_blank' : undefined}>
                     {<i.icon className='footer-item-icon' />}
                     <span className='footer-item-text'>{i.text}</span>
                  </Link>
               ))}
            </div>
         </div>
         <div className='footer-socials-container'>
            <div className='footer-column-container'>
               <h4 className='footer-column-title'>Nuestras redes</h4>
               {footerItems.filter(item => !item.isContactItem).map(i => (
                  <Link key={i.text} to={i.to} target='_blank' className='footer-item-container'>
                     {<i.icon className='footer-item-icon' />}
                     <span className='footer-item-text'>{i.text}</span>
                  </Link>
               ))}
            </div>

         </div>
        
      </div>
   )
}
